import {
  SET_PRISMIC_DOCUMENT_UID,
  SET_OVERVIEW_NAV_TAB_IDX,
  SET_BREEDER_POST_DATA,
  SET_SEARCH_ALERTS_DISMISSED
} from 'dpl/actions/server';

export default function serverReducer(state = {}, action) {
  const { payload, type } = action;

  if (
    type === SET_PRISMIC_DOCUMENT_UID ||
    type === SET_OVERVIEW_NAV_TAB_IDX ||
    type === SET_BREEDER_POST_DATA ||
    type === SET_SEARCH_ALERTS_DISMISSED
  ) {
    return {
      ...state,
      ...payload
    };
  }

  return state;
}
